export default "__VITE_ASSET__BwVvselQ__"